<!--
트래킹검수 > 검수화면 > 검수대상 리스트 컴포넌트 > 일괄검수 >
상품1개 정보
------------------------------------
-->
<template>
    <tbody>


    <tr class="prod-row">
       <td rowspan="2">
           <app-batch-item-checker
               :item="prod.checkbox"
               v-if="prod.checkbox"
               :disabled="disableCheckbox"
           ></app-batch-item-checker>
       </td>
        <td rowspan="2">
           <a :href="prod.img_url" target="_blank" title="새 탭에서 원본 사이즈로 보기">
               <img
                   :src="prod.img_url"
                   :data-src="prod.img_url"
                   class=" lazyloaded"
                   style="object-fit: contain; width: 100px; height: 100px;"
               />
           </a>
       </td>

        <td>
            <button
                class="uk-button uk-button-primary"
                @click="$refs.ok.form()"
            >
                정상
            </button>

            <!-- 컴포넌트 -->
            <app-check-set-ok
                ref="ok"
                :csrf-token="csrfToken"
                :prod-id="prod.id"
                @done:ready="callbackReady"
                @done:pack="house_id => callbackPack(house_id)"
            >
            </app-check-set-ok>
        </td>

        <td class="amount" :class="prod.amount > 1 ? 'highlight' : ''">
           {{ prod.amount }}
        </td>
        <td class="size highlight">
           {{ prod.size }}
        </td>
        <td class="color highlight">
           {{ prod.color }}
        </td>
        <td class="sku" :class="prod.vender_code? 'highlight' : ''">
           {{ prod.vender_code }}
        </td>

        <td class="name">
           {{ prod.name }}
        </td>
        <td class="name">
          {{ prod.unit_price_text }}
        </td>
        <td>
            <a class="uk-link-reset" :href="'/prods/'+prod.id" target="_blank" title="상세페이지 팝업">
                <i class="material-icons">link</i>
            </a>
        </td>

        <td>
           <button
               class="uk-button uk-button-danger"
               @click="$refs.error.form()"
           >
               오류
           </button>

           <!---- 컴포넌트 -->
           <app-check-set-error
               ref="error"
               :csrf-token="csrfToken"
               :prod-id="prod.id"
               :session-owner="loginUserId"
               @done="callbackErrorDone"
           ></app-check-set-error>
        </td>
        <td>
           <button
               v-if="displayHoldButton"
               class="uk-button uk-button-primary"
               @click="$refs.hold.form()"
           >
               보류
           </button>

           <!-- 컴포넌트 -->
           <app-check-set-hold
               ref="hold"
               :csrf-token="csrfToken"
               :prod-id="prod.id"
               :hold-request="prod.hold_request"
               @done="callbackHoldDone"
           >
           </app-check-set-hold>

        </td>
    </tr>

    <tr>
        <td colspan="9" class="msgs">
            <!-- 검수요청사항 -->
            <div class="uk-flex uk-flex-left uk-flex-top uk-flex-wrap" v-if="prod.check_requests.length > 0">
                <div class="check-req">
                    <i class="material-icons">star</i>
                    검수요청
                </div>
                <request
                    v-for="req in prod.check_requests"
                    :key="req.id"
                    :request="req.request"
                    class="uk-margin-bottom uk uk-margin-right"
                ></request>
            </div>


            <!-- 보류요청사항 -->
            <div class="uk-flex uk-flex-left uk-flex-top uk-flex-wrap" v-if="prod.lock_hold_req">
                <div class="hold-req">
                    <i class="material-icons">star</i>
                    보류요청
                </div>
                <request
                    v-if="prod.hold_request"
                    :request="prod.hold_request.hold_reason"
                    class="uk-margin-bottom uk uk-margin-right"
                ></request>
            </div>
        </td>
    </tr>
    </tbody>
</template>

<script>
    export default {
        components: {
            'request': require('../../request.vue').default,
        },

        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },

            /**
             * 상품정보
             */
            prod: {
                type: Object,
                default: null,
            },

            /**
             * 체크박스 disable 여부
             */
            disableCheckbox: {
                type: Boolean,
                default: false,
            },
        },

        data: function () {
            return {
            };
        },

        computed: {
            /**
             * 보류보관 버튼 표시
             * @return bool
             */
            displayHoldButton: function () {
                return this.prod.lock_hold_req !== null
                    && this.prod.state !== 99
                    && this.prod.lock_return === null; // 반품신청 없을때만
            },
        },

        methods: {
            /**
             * 에러완료 이벤트 리스너
             */
            callbackErrorDone: function () {
                this.$emit('done:error', null);
            },

            /**
             * 보류완료 이벤트 리스너
             */
            callbackHoldDone: function () {
                this.$emit('done:hold', null);
            },

            /**
             * 정상(발송대기) 이벤트 리스너
             */
            callbackReady: function () {
                this.$emit('done:ready', null);
            },

            /**
             * 정상(패킹대기) 이벤트 리스너
             */
            callbackPack: function (house_id) {
                this.$emit('done:pack', house_id);
            },

        },
    }
</script>

<style lang="scss" scoped>
    .prod-row {

        td {
            font-size: 1.25rem;
            text-align: center;
            padding: 5px;
            font-weight: normal;
            border: 1px solid #cfcfcf;
            border-top: 2px solid #000;
            color: #000;

            &.amount, &.size, &.color, &.sku {
                font-size: 2rem;
                color: #000;
            }

            &.highlight {
                background-color: #ffffdd !important;

                &.sku {
                    color: #f0506e!important;
                    font-weight: bold;
                }

                &.amount {
                    color: #1e87f0 !important;
                    font-weight: bold;

                }
            }

            &.name {
                text-align: left;
            }



            .uk-checkbox {
                width: 20px;
                height: 20px;
            }

            .material-icons {
                vertical-align: middle;
                font-size: 28px;
            }

            // 버튼 글씨크기
            .uk-button {
                font-size: 1.25rem;
            }


        }



        &:hover td {
            background-color: #e6f5ff;
        }



    }

    // 요청사항
    .msgs {
        padding: 1rem;
    }

    // 검수요청
    .check-req {
        display: inline-block;
        color: #000;
        background-color: #f5f8fa;
        border: 2px solid #666;
        border-radius: 15px;
        padding: 5px 10px;
        text-decoration: none;
        margin-right: 1rem;

        .material-icons {
            vertical-align: middle;
            font-size: 20px;
            color: #1e87f0 !important;
        }
    }

    // 보류요청
    .hold-req {
        display: inline-block;
        color: #000;
        background-color: #ffe3e5;
        border: 2px solid #666;
        border-radius: 15px;
        padding: 5px 10px;
        text-decoration: none;
        margin-right: 1rem;

        .material-icons {
            vertical-align: middle;
            font-size: 20px;
            color: #1e87f0 !important;
        }
    }
</style>